import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from '@shared/profile/profile.component';

import { MsalGuard } from '@azure/msal-angular';
import { AppLayoutComponent } from '../theme/app-layout/app-layout.component';
import { CallbackComponent } from './authentication/callback/callback.component';
import { PrivacyComponent } from './privacy/privacy.component';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      { path: 'profile', component: ProfileComponent, canActivate: [MsalGuard] },
      { path: 'authentication/callback', component: CallbackComponent },
      {
        path: 'privacy',
        component: PrivacyComponent
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard/3' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      relativeLinkResolution: 'legacy',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class RoutesRoutingModule {}
